import React, {
  useContext, useEffect, useState, useCallback,
} from 'react';
import { IconButton, IconClose, IconList } from '@americanexpress/dls-react';
import { withRouter } from '@americanexpress/one-app-router';
import PropTypes from 'prop-types';
import { addErrorToReport } from '@americanexpress/one-app-ducks';
import { useDispatch } from 'react-redux';
import NavigationComponent from './NavigationComponent';
import useApiWithSession from '../utility/useApiWithSession';
import { PaymentContext } from '../utility/PaymentContext';
import { TokenContext } from '../utility/TokenContext';

const Header = ({ router }) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const [event, setEvent] = useState('HAMBURGER_OPEN');
  const {
    market1, journey1, sid1, u1, paymentResponse,
  } = useContext(PaymentContext);
  const { gateWayUrl } = useContext(TokenContext);

  const {
    isLoading, data, error, run,
  } = useApiWithSession({
    url: `${gateWayUrl}/voice/v1/multimodal/events`,
    sid1,
    method: 'PUT',
    body: { eventName: event },
    customHeaders: {
      session_id: sid1,
      correlation_id: u1,
      consumer: 'GUI',
      market: market1,
      journey: journey1,
    },
    router,
  });
  const dispatch = useDispatch();

  useEffect(() => {
    if (isLoading === false && (error && data?.body?.statusCode === 'failure')) {
      router.push({ pathname: '/message', query: { level: 3 } });
    }
  }, [isLoading, error, data, router]);

  const handleHamburgerToggle = useCallback(async () => {
    const sessionId = document.cookie
      .split('; ')
      .find((row) => row.startsWith('session_id='))
      ?.split('=')[1];
    if (!sessionId || !paymentResponse) {
      const err = new Error('Session ID is missing or response is missing');
      dispatch(addErrorToReport(err, { message: 'Welcome: Missing session ID or payment response.' }));
      router.push({ pathname: '/message', query: { level: 3 } });
    }
    setIsExpanded((prev) => !prev);
    setEvent((prev) => (prev === 'HAMBURGER_CLOSE' ? 'HAMBURGER_OPEN' : 'HAMBURGER_CLOSE'));
    await run();
  }, [run]);

  return (
    <nav className="nav nav-header nav-large nav-inverse nav-vertical nav-sticky" data-toggle="nav" data-responsive="true">
      <div className="nav-overlay" />
      {sid1 && (
        <IconButton
          className="focus-dark dls-bright-blue-bg margin-1-l card-rounded"
          aria-label="Toggle navigation"
          aria-haspopup="true"
          aria-expanded={isExpanded}
          onClick={handleHamburgerToggle}
          style={{ height: '80%', position: 'static' }}
          shape="square"
          variant="primary"
          icon={<IconList />}
          disabled={!sid1}
        >
          {isExpanded ? (
            <IconClose
              title="Close navigation"
              titleId="close-icon-id"
              size="md"
              className="dls-white"
            />
          ) : (
            <IconList
              title="Open navigation"
              titleId="list-icon-id"
              size="md"
              className="dls-white"
            />
          )}
        </IconButton>
      )}
      {isExpanded && (
        <div className="nav-menu" style={{ width: '100vw' }}>
          <NavigationComponent />
        </div>
      )}
      <div className="nav-brand dls-logo-line-md">
        <span className="dls-logo-stack-xs">
          <img
            src="https://www.aexp-static.com/cdaas/one/statics/@americanexpress/static-assets/2.28.0/package/dist/img/logos/dls-logo-stack.svg"
            alt="American Express"
          />
        </span>
      </div>
    </nav>
  );
};

export default withRouter(Header);

Header.propTypes = {
  router: PropTypes.instanceOf(Object).isRequired,
};
